import React, { Component } from 'react'
import { Button, Popover, OverlayTrigger, Modal, Col } from 'react-bootstrap'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share'
import { StickyContainer, Sticky } from 'react-sticky'
import FormContact from '../../../../features/commons/ContactForm/ContactForm.container'
import { translate } from 'react-translate'

@translate('StickyMenu')
class StickyMenu extends Component{

  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  changeViewModal() {
    this.setState({showModal: !this.state.showModal })
  }

  render() {

    const { property, t } = this.props

    //Social Share
    let baseUrl = window.location.origin
    let shareUrl = baseUrl + '/' + property.uri

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const title = 'LJ Ramos'

    const popoverShare = (
      <Popover id='popover-share'>
        <FacebookShareButton
          url={shareUrl}
          title={title}>
          <FacebookIcon
            size={20}
            round={false} />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}>
          <TwitterIcon
            size={20} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}>
          <LinkedinIcon
            size={20} />
        </LinkedinShareButton>
      </Popover>
    )

    return (
      <div className='hidden-xs'>
        <Sticky className='sticky-menu' topOffset={80} stickyClassName='sticky-visible'>
          <div className='pull-left'>
            <Button className='btn-contact' onClick={() => this.changeViewModal()}>{t('Consultar_propiedad')}</Button>
          </div>
          <div className='pull-right'>
            <OverlayTrigger trigger='click' rootClose placement='bottom' overlay={popoverShare}>
              <Button>
                <i className='fa fa-share-alt fa-lg'></i>
              </Button>
            </OverlayTrigger>
          </div>
        </Sticky>
        <Modal
            className='modal-contact-form'
            show={this.state.showModal}
            onHide={(e) => this.changeViewModal(e)}
            aria-labelledby='contained-modal-title'
            bsSize='large'
          >
          <Modal.Body>
            <div className='form-box'>
              <div className='form-content form-slider'>
                <Col md={12} sm={12} className='inputs-form form-modal hidden-xs'>
                  <FormContact property={property} />
                </Col>
                <div className='col-md-12 inputs-form visible-xs'>
                  <FormContact property={property} />
                </div>
              </div>
              <div className='box-close'>
                <Button type='submit' className='btn-close' onClick={() => this.changeViewModal()}>
                  <i className='fa fa-times fa-lg'></i>
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default StickyMenu



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/stickyMenu.js